import React from 'react';
import { WorkspaceInstances } from './formInstances';
import { FormProvider } from '../fluidComponents/fluidForm/FormContext';
import { DocFluidForm } from '../fluidComponents/fluidForm/DocFluidForm.component';
import { useFormUpdatedListener } from '../fluidComponents/fluidForm/FormInstance.service';
function ActionsTabContent({ configRecord, onChange: onConfigRecordChange }) {
    const handleActionsChange = (newActionsConfig) => {
    };
    useFormUpdatedListener(WorkspaceInstances.actionsConfig, (submission) => {
        const updatedRecord = {
            ...configRecord,
            actionsConfig: submission
        };
        onConfigRecordChange(updatedRecord);
    });
    return (React.createElement("div", null,
        React.createElement("h1", null, "Actions"),
        React.createElement("p", null, "Define where the structured form data should be sent when the form is submitted"),
        React.createElement(FormProvider, { formInstance: WorkspaceInstances.actionsConfig },
            React.createElement(DocFluidForm, { hideInputModes: true, useUpdateChat: false, rounded: false, showSubmitButton: false, fieldProps: {
                    useInstantValidation: false,
                    hideHelpButton: true
                } }))));
}
export default ActionsTabContent;
